import React, { useEffect, useState } from "react";
import styles from "../../../styles.module.scss";
import Form, { NewSelectField } from "@components/form";
import { sinkOptions } from "../constant";
import { _selectoptionType } from "@components/form/select-field";
import { DataSourceHandler } from "@api/data-source-handler";
import { useSelector } from "react-redux";
import { RootState } from "@store/types";

interface HierarchyFormProps {
    activeStep: number;
    setActiveStep: (step: number) => void;
    initialValues: any;
    formSchema: any;
    handleOnSubmit: (values: any) => void;
}

const HierarchySinkForm: React.FC<HierarchyFormProps> = ({
    activeStep,
    setActiveStep,
    initialValues,
    formSchema,
    handleOnSubmit
}) => {
    const [sinkNameOptions, setSinkNameOptions] = useState<_selectoptionType[]>([])
    const { envVariables: Env } = useSelector((store: RootState) => store.AccountReducer);

    const getSinkNames = () => {
        DataSourceHandler.GetSinkNodes(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, (res) => {
            const filteredSinkNames = res
                .filter((_res: any) => _res.sinkKind === "S3")
                .map((_res: any) => ({
                    label: _res.sinkName,
                    value: _res.sinkName,
                    type: _res.sinkKind
                }));

            setSinkNameOptions(filteredSinkNames);
        });
    };

    useEffect(() => {
        getSinkNames();
    }, [])

    return (
        <>
            <Form
                initialValues={initialValues}
                onSubmit={handleOnSubmit}
                validationSchema={formSchema}
                enableReinitialize
            >
                {({ _formikprops: { values, setFieldValue } }) => (
                    <>
                        <div className={styles.jsonHierarchyForm}>
                            <div style={{ padding: 16 }}>
                                <NewSelectField
                                    name="sinkKind"
                                    label="Type"
                                    options={sinkOptions}
                                    required={true}
                                    className={styles["requestName__field"]}
                                />
                                <NewSelectField
                                    name="sinkName"
                                    label="Name"
                                    options={sinkNameOptions}
                                    required={true}
                                    className={styles["requestName__field"]}
                                />
                            </div>
                        </div>
                        <div className={styles.hierarchyFormFooter}>
                            <button type="button" className="btn btn-grey btn-md" onClick={() => { setActiveStep(activeStep - 1); }}>
                                Back
                            </button>
                            <button type="submit" className="btn btn-yellow btn-md" >
                                Next
                            </button>
                        </div>
                    </>
                )}
            </Form>
        </>
    );
};

export default HierarchySinkForm;
